import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	schemeCount: {
		id: 'admin-pages-priorities.priorities-table.schemes.scheme-count',
		defaultMessage: '{schemeCount, plural, one {# scheme} other {# schemes}}',
		description: 'Message to display the number of associated priority schemes for a priority',
	},
	noSchemes: {
		id: 'admin-pages-priorities.priorities-table.schemes.no-schemes',
		defaultMessage: 'No schemes',
		description: 'Message to display when a priority has no associated schemes',
	},
});
